const USER_ACTIONS = {
  //get user
  GET_USERS_REQUEST: "GET_USERS_REQUEST",
  GET_USERS_REQUEST_SUCCESS: "GET_USERS_REQUEST_SUCCESS",
  GET_USERS_REQUEST_FAIL: "GET_USERS_REQUEST_FAIL",
  // get user by ID
  GET_USERS_BY_ID_REQUEST: "GET_USERS_BY_ID_REQUEST",
  GET_USERS_BY_ID_REQUEST_SUCCESS: "GET_USERS_BY_ID_REQUEST_SUCCESS",
  GET_USERS_BY_ID_REQUEST_FAIL: "GET_USERS_BY_ID_REQUEST_FAIL",
  //update user
  UPDATE_USERS_REQUEST: "UPDATE_USERS_REQUEST",
  UPDATE_USERS_REQUEST_SUCCESS: "UPDATE_USERS_REQUEST_SUCCESS",
  UPDATE_USERS_REQUEST_FAIL: "UPDATE_USERS_REQUEST_FAIL",
  //add user
  ADD_USERS_REQUEST: "ADD_USERS_REQUEST",
  ADD_USERS_REQUEST_SUCCESS: "ADD_USERS_REQUEST_SUCCESS",
  ADD_USERS_REQUEST_FAIL: "ADD_USERS_REQUEST_FAIL",
  //del user
  DEL_USERS_REQUEST: "DEL_USERS_REQUEST",
  DEL_USERS_REQUEST_SUCCESS: "DEL_USERS_REQUEST_SUCCESS",
  DEL_USERS_REQUEST_FAIL: "DEL_USERS_REQUEST_FAIL",
  //get user shift time
  GET_USER_SHIFT_OVERTIME: "GET_USER_SHIFT_OVERTIME",
  GET_USER_SHIFT_OVERTIME_SUCCESS: "GET_USER_SHIFT_OVERTIME_SUCCESS",
  GET_USER_SHIFT_OVERTIME_FAIL: "GET_USER_SHIFT_OVERTIME_FAIL",
  //get user checktime
  GET_USERS_CHECKTIME_REQUEST: "GET_USERS_CHECKTIME",
  GET_USERS_CHECKTIME_SUCCESS: "GET_USERS_CHECKTIME_SUCCESS",
  GET_USERS_CHECKTIME_FAIL: "GET_USERS_CHECKTIME_FAIL",
  //change user password
  CHANGE_USER_PASSWORD: "CHANGE_USER_PASSWORD",
  CHANGE_USER_PASSWORD_SUCCESS: "CHANGE_USER_PASSWORD_SUCCESS",
  CHANGE_USER_PASSWORD_FAIL: "CHANGE_USER_PASSWORD_FAIL",
  //change user password by ID
  CHANGE_USER_PASSWORD_BY_ID: "CHANGE_USER_PASSWORD_BY_ID",
  CHANGE_USER_PASSWORD_BY_ID_SUCCESS: "CHANGE_USER_PASSWORD_BY_ID_SUCCESS",
  CHANGE_USER_PASSWORD_BY_ID_FAIL: "CHANGE_USER_PASSWORD_BY_ID_FAIL",
  //get user infomation
  GET_BASIC_PROFILE_REQUEST: "GET_BASIC_PROFILE_REQUEST",
  GET_BASIC_PROFILE_REQUEST_FAIL: "GET_BASIC_PROFILE_REQUEST_FAIL",
  GET_BASIC_PROFILE_REQUEST_SUCCESS: "GET_BASIC_PROFILE_REQUEST_SUCCESS",
  //get user of all branches
  GET_USER_ALL_BRANCHES: "GET_USER_ALL_BRANCHES",
  GET_USER_ALL_BRANCHES_SUCCESS: "GET_USER_ALL_BRANCHES_SUCCESS",
  GET_USER_ALL_BRANCHES_FAIL: "GET_USER_ALL_BRANCHES_FAIL",
  //add user to branch
  POST_USER_BRANCH: "POST_USER_BRANCH",
  POST_USER_BRANCH_SUCCESS: "POST_USER_BRANCH_SUCCESS",
  POST_USER_BRANCH_FAIL: "POST_USER_BRANCH_FAIL",
  //remove user in branch
  REMOVE_USER_BRANCH: "REMOVE_USER_BRANCH",
  REMOVE_USER_BRANCH_SUCCESS: "REMOVE_USER_BRANCH_SUCCESS",
  REMOVE_USER_BRANCH_FAIL: "REMOVE_USER_BRANCH_FAIL",
  //LOCK USER
  POST_USER_LOCK_BY_ID_REQUEST: "POST_USER_LOCK_BY_ID_REQUEST",
  POST_USER_LOCK_BY_ID_REQUEST_SUCCESS: "POST_USER_LOCK_BY_ID_REQUEST_SUCCESS",
  POST_USER_LOCK_BY_ID_REQUEST_FAIL: "POST_USER_LOCK_BY_ID_REQUEST_FAIL",
  //get user
  GET_TEAMS_REQUEST: "GET_TEAMS_REQUEST",
  GET_TEAMS_REQUEST_SUCCESS: "GET_TEAMS_REQUEST_SUCCESS",
  GET_TEAMS_REQUEST_FAIL: "GET_TEAMS_REQUEST_FAIL",
  //get all job type
  GET_ALL_JOB_TYPE: "GET_ALL_JOB_TYPE",
  GET_ALL_JOB_TYPE_SUCCESS: "GET_ALL_JOB_TYPE_SUCCESS",
  GET_ALL_JOB_TYPE_FAIL: "GET_ALL_JOB_TYPE_FAIL",
  //get user shift time
  GET_USER_SHIFT_TIME: "GET_USER_SHIFT_TIME",
  GET_USER_SHIFT_TIME_SUCCESS: "GET_USER_SHIFT_TIME_SUCCESS",
  GET_USER_SHIFT_TIME_FAIL: "GET_USER_SHIFT_TIME_FAIL",
  //update resident card
  UPDATE_RESIDENT_CARD: "UPDATE_RESIDENT_CARD",
  UPDATE_RESIDENT_CARD_SUCCESS: "UPDATE_RESIDENT_CARD_SUCCESS",
  UPDATE_RESIDENT_CARD_FAIL: "UPDATE_RESIDENT_CARD_FAIL",
  //update emergency contact
  UPDATE_EMERGENCY_CONTACT: "UPDATE_EMERGENCY_CONTACT",
  UPDATE_EMERGENCY_CONTACT_SUCCESS: "UPDATE_EMERGENCY_CONTACT_SUCCESS",
  UPDATE_EMERGENCY_CONTACT_FAIL: "UPDATE_EMERGENCY_CONTACT_FAIL",
  //get emergency contact
  GET_EMERGENCY_CONTACT_REQUEST: "GET_EMERGENCY_CONTACT_REQUEST",
  GET_EMERGENCY_CONTACT_REQUEST_FAIL: "GET_EMERGENCY_CONTACT_REQUEST_FAIL",
  GET_EMERGENCY_CONTACT_REQUEST_SUCCESS:
    "GET_EMERGENCY_CONTACT_REQUEST_SUCCESS",
  //get user report
  GET_USER_REPORT: "GET_USER_REPORT",
  GET_USER_REPORT_SUCCESS: "GET_USER_REPORT_SUCCESS",
  GET_USER_REPORT_FAIL: "GET_USER_REPORT_FAIL",
  // TODO remove it if API /get-basic-profile return qrcode
  GET_USER_QR_CODE: "GET_USER_QR_CODE",
};
export default USER_ACTIONS;
